import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import H5Index from '../views/H5Index.vue'
import Article from '../views/Article.vue'
import H5Article from '../views/H5Article.vue'
import ArticleList from '../views/ArticleList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/h5',
    name: 'H5Index',
    component: H5Index
  },
  {
    path: '/article',
    name: 'Article',
    component: Article
  },
  {
    path: '/h5_article',
    name: 'H5Article',
    component: H5Article
  },
  {
    path: '/articleList',
    name: 'ArticleList',
    component: ArticleList
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach(() => {
  window.scrollTo(0,0);
  // next();
});

export default router
